import React from 'react';
import Dashboard from '../components/Dashboard';

const HomePage: React.FC = () => {
  return (
    <Dashboard />
  );
}

export default HomePage;
